module.exports = __webpack_public_path__ + "static/smoke-1-ac8355e03abcf35d7327a239f7e666da.mp4";